import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
import NoteSend from './NoteSend';
import NoteList from './NoteList';

/* 工具 */
import { ref, onMounted } from 'vue';
import { DialogPlugin, MessagePlugin } from 'tdesign-vue-next';
import { fabric } from 'fabric-with-erasing';
import { getStore } from '@/util/store';
import jsPDF from 'jspdf';

/* api */
import { getCanvasDrawId } from '@/api/index-bei-discuss';

/* 变量 */

export default {
  __name: 'index',
  props: {
    canvasObj: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    roleId: {
      type: [String, Number],
      default: ''
    },
    w: {
      type: Number,
      default: 0
    },
    h: {
      type: Number,
      default: 0
    }
  },
  emits: ['update:canvasObj', 'change'],
  setup: function setup(__props, _ref) {
    var _getStore;
    var __expose = _ref.expose,
      __emit = _ref.emit;
    /* 组件 */
    var props = __props;

    // 页面变量
    var canvasRef = ref(null); // 画布dom
    var canvasBoxRef = ref(null); // 画布盒子dom
    var noteSendShow = ref(false); // 发送批注组件显隐
    var noteListShow = ref(false); // 批注列表组件显隐
    var noteX = ref(0); // 发送批注组件坐标x
    var noteY = ref(0); // 发送批注组件坐标y
    var noteInfo = ref({}); // 当前点击的批注点信息

    // 非页面变量
    var emit = __emit;
    var userId = (_getStore = getStore({
      name: 'userInfo'
    })) === null || _getStore === void 0 ? void 0 : _getStore.id;
    var canvasObj = null; // 画布实例
    var toolInfo = {}; // 当前画布工具信息
    var editing = ''; // 当前编辑状态
    var isMouseDown = false; // 是否鼠标按下
    var startRubber = false; // 是否开始擦除
    var rubberMouse = null; // 橡皮擦鼠标跟随
    var savingPDF = false; // 是否正在保存pdf
    var textDeleteObj = null; // 文本删除对象
    var textDeleteIcon = null; // 文本删除图标

    /* 事件 */
    // 初始化画布
    var initCanvas = function initCanvas() {
      var _canvasBoxRef$value = canvasBoxRef.value,
        clientWidth = _canvasBoxRef$value.clientWidth,
        clientHeight = _canvasBoxRef$value.clientHeight;
      canvasObj = new fabric.Canvas(canvasRef.value, {
        width: props.w || clientWidth,
        height: props.h || clientHeight,
        selection: false // 禁止选中内容
      });
      // 监听文本改变事件
      canvasObj.on('object:modified', textModified);
      // 监听文本双击事件
      canvasObj.on('mouse:dblclick', textMouseDbClick);
      // 监听文本双击事件
      canvasObj.on('mouse:move', textMouseMove);
      // 监听画布点击事件
      canvasObj.on('mouse:down', canvasMouseDown);
      // 监听鼠标抬起事件
      canvasObj.on('mouse:up', canvasMouseUp);
      // 画布实例双向绑定
      emit('update:canvasObj', canvasObj);
    };

    // 生成唯一id
    var getDrawId = function getDrawId() {
      return new Promise(function (resolve) {
        getCanvasDrawId().then(function (res) {
          if (res.data.code === 0) {
            resolve(res.data.data);
          }
        });
      });
    };

    // 生成图片对象
    var getImgFabric = function getImgFabric(url, params) {
      return new Promise(function (resolve) {
        fabric.Image.fromURL(url, function (loadedSvg) {
          var opt = _objectSpread({
            originX: 'center',
            originY: 'center'
          }, params);
          loadedSvg.set(opt);
          resolve(loadedSvg);
        });
      });
    };

    // 画布鼠标抬起，让所有批注点置顶
    var canvasMouseUp = function canvasMouseUp() {
      isMouseDown = false;
      canvasObj.getObjects().forEach(function (obj) {
        if (obj.type === 'group') {
          obj.bringToFront();
        }
      });
    };

    // 点击批注点时
    var canvasMouseDown = function canvasMouseDown(e) {
      isMouseDown = true;
      var target = e.target;
      if ((target === null || target === void 0 ? void 0 : target.elType) === 'note') {
        var left = target.left,
          top = target.top;
        var listX = left + 16;
        var listY = top - 16;
        var canvasW = canvasObj.width;
        var canvasH = canvasObj.height;
        var mouseX = e.pointer.x;
        var mouseY = e.pointer.y;
        if (canvasW - mouseX < 300) {
          listX = left - 300 - 16;
        }
        if (canvasH - mouseY < 350) {
          listY = top - 300 - 6;
        }
        noteX.value = listX;
        noteY.value = listY;
        noteInfo.value = {
          id: target.drawId,
          ownerId: target.ownerId
        };
        noteListShow.value = true;
      } else if ((target === null || target === void 0 ? void 0 : target.elType) === 'text-del') {
        if (textDeleteObj) {
          // 移除文本元素
          emit('change', {
            optType: 'textdel',
            drawId: textDeleteObj.drawId
          });
          canvasObj.remove(textDeleteObj);
          removeTextDeleteIcon();
        }
      }
    };

    // 判断当前是否有删除/编辑元素权限
    var isHavePermission = function isHavePermission(ownerId) {
      var isMineCanvas = props.roleId === userId;
      var isMineDraw = ownerId === userId;
      return isMineCanvas || isMineDraw;
    };

    /************ 画笔工具 ************/
    // 添加画笔元素
    var brushObjectAdded = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
        var _target$path;
        var target, drawId;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              target = e.target;
              if (!(target && (_target$path = target.path) !== null && _target$path !== void 0 && _target$path.length && !target.elType)) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return getDrawId();
            case 1:
              drawId = _context.v;
              target.set({
                drawId: drawId,
                // 元素唯一id
                ownerId: userId,
                // 所属者id
                elType: 'brush',
                // 元素类型
                selectable: false,
                // 不可选中
                hasControls: false,
                // 不可操控
                hoverCursor: 'default' // 鼠标悬浮样式
              });
              emit('change', {
                optType: 'penciladd',
                drawId: drawId,
                drawContent: JSON.stringify(target.toJSON())
              });
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function brushObjectAdded(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    /************ 文本工具 ************/
    // 文本鼠标按下
    var textMouseDown = function textMouseDown(e) {
      var target = e.target;
      var addText = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
          var drawId, text;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                _context2.n = 1;
                return getDrawId();
              case 1:
                drawId = _context2.v;
                text = new fabric.IText('请输入', {
                  drawId: drawId,
                  ownerId: userId,
                  // 所属者id
                  elType: 'text',
                  // 元素类型
                  hasControls: false,
                  // 不可操控
                  hoverCursor: 'text',
                  // 鼠标悬浮样式
                  left: e.pointer.x,
                  top: e.pointer.y,
                  fontSize: toolInfo.thickness,
                  fill: toolInfo.color
                });
                canvasObj.add(text).setActiveObject(text);
                text.enterEditing();
                text.on('moving', function () {
                  removeTextDeleteIcon();
                });
                editing = 'text';
                emit('change', {
                  optType: 'textadd',
                  drawId: drawId,
                  drawContent: JSON.stringify(text.toJSON())
                });
              case 2:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function addText() {
          return _ref3.apply(this, arguments);
        };
      }();
      if (editing === 'text') {
        // 当前在编辑文本模式下，不添加元素，退出编辑模式
        editing = '';
        return;
      }
      var isTextType = (target === null || target === void 0 ? void 0 : target.elType) === 'text'; // 当前点击元素是否为文本
      if (!target || target && !isTextType) {
        // 点击空白区域，或者点击元素不是文本，就添加元素
        addText();
      }
    };

    // 移除文本删除图标
    var removeTextDeleteIcon = function removeTextDeleteIcon() {
      if (textDeleteIcon) {
        textDeleteObj = null;
        canvasObj.remove(textDeleteIcon);
        textDeleteIcon = null;
      }
    };

    // 文本鼠标移入
    var textMouseMove = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(e) {
        var target, bool1, bool2, bool3, svg;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!isMouseDown) {
                _context3.n = 1;
                break;
              }
              removeTextDeleteIcon();
              return _context3.a(2);
            case 1:
              target = e.target;
              if (!target) {
                _context3.n = 6;
                break;
              }
              if (!(target.elType === 'text-del')) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2);
            case 2:
              bool1 = !isHavePermission(target === null || target === void 0 ? void 0 : target.ownerId); // 没有操作权限
              bool2 = editing === 'text'; // 当前正在编辑文本
              bool3 = (target === null || target === void 0 ? void 0 : target.elType) !== 'text'; // 当前元素不为文本
              if (!(bool1 || bool2 || bool3)) {
                _context3.n = 3;
                break;
              }
              removeTextDeleteIcon();
              return _context3.a(2);
            case 3:
              if (bool3) {
                _context3.n = 5;
                break;
              }
              if (textDeleteIcon) {
                _context3.n = 5;
                break;
              }
              svg = require('@/assets/discuss/delete-text.png');
              _context3.n = 4;
              return getImgFabric(svg, {
                elType: 'text-del',
                // 元素类型
                left: target.left + target.width,
                top: target.top,
                selectable: false,
                // 不可选中
                hasControls: false,
                // 不可操控
                hoverCursor: 'pointer' // 鼠标悬浮样式
              });
            case 4:
              textDeleteIcon = _context3.v;
              canvasObj.add(textDeleteIcon);
              canvasObj.renderAll();
              textDeleteObj = target;
            case 5:
              _context3.n = 7;
              break;
            case 6:
              removeTextDeleteIcon();
            case 7:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function textMouseMove(_x2) {
        return _ref4.apply(this, arguments);
      };
    }();

    // 双击文本
    var textMouseDbClick = function textMouseDbClick(e) {
      removeTextDeleteIcon();
      var target = e.target;
      if (!isHavePermission(target === null || target === void 0 ? void 0 : target.ownerId)) return;
      if (target && target.elType === 'text') {
        editing = 'text';
        target.enterEditing();
      }
    };

    // 文本编辑/移动事件
    var textModified = function textModified(e) {
      var _e$target;
      removeTextDeleteIcon();
      if (e !== null && e !== void 0 && e.target && ((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.elType) === 'text') {
        var _e$target2 = e.target,
          text = _e$target2.text,
          drawId = _e$target2.drawId;
        if ((text === null || text === void 0 ? void 0 : text.length) > 0) {
          emit('change', {
            optType: 'textedit',
            drawId: drawId,
            drawContent: JSON.stringify(e.target.toJSON())
          });
        } else {
          emit('change', {
            optType: 'textdel',
            drawId: drawId
          });
        }
      }
    };

    /************ 橡皮工具 ************/
    // 添加橡皮鼠标
    var addRubberMouse = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
        var svg;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (rubberMouse) {
                _context4.n = 2;
                break;
              }
              svg = require('@/assets/discuss/rubber.png');
              _context4.n = 1;
              return getImgFabric(svg, {
                elType: 'rubber',
                // 元素类型
                left: e.pointer.x,
                top: e.pointer.y
              });
            case 1:
              rubberMouse = _context4.v;
              canvasObj.add(rubberMouse);
              canvasObj.renderAll();
            case 2:
              rubberMouse.set({
                left: e.pointer.x,
                top: e.pointer.y
              });
              canvasObj.renderAll();
            case 3:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      return function addRubberMouse(_x3) {
        return _ref5.apply(this, arguments);
      };
    }();
    // 橡皮鼠标按下
    var rubberMouseDown = function rubberMouseDown() {
      startRubber = true;
    };

    // 检测直线是否相交
    var lineLine = function lineLine(x1, y1, x2, y2, x3, y3, x4, y4) {
      // Check if none of the lines are of length 0
      if (x1 === x2 && y1 === y2 || x3 === x4 && y3 === y4) {
        return false;
      }
      var denominator = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);

      // Lines are parallel
      if (denominator === 0) {
        return false;
      }
      var ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / denominator;
      var ub = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) / denominator;

      // is the intersection along the segments
      if (ua < 0 || ua > 1 || ub < 0 || ub > 1) {
        return false;
      }

      // Return a object with the x and y coordinates of the intersection
      return true;
    };

    // 计算橡皮轨迹交叉
    var doPathsIntersect = function doPathsIntersect(path1, path2) {
      for (var i = 0; i < path1.length - 1; i++) {
        for (var j = 0; j < path2.length - 1; j++) {
          if (lineLine(path1[i][1], path1[i][2], path1[i + 1][1], path1[i + 1][2], path2[j][1], path2[j][2], path2[j + 1][1], path2[j + 1][2])) {
            return true;
          }
        }
      }
      return false;
    };

    // 监听橡皮移动
    var rubberMouseMove = function rubberMouseMove(e) {
      var target = e.target;
      addRubberMouse(e);
      if (!isHavePermission(target === null || target === void 0 ? void 0 : target.ownerId)) return;
      if (startRubber && target) {
        if (target.elType === 'text') {
          // 移除文本元素
          emit('change', {
            optType: 'textdel',
            drawId: target.drawId
          });
          canvasObj.remove(target);
        } else if (target.elType === 'brush') {
          // 移除画笔元素
          var pots = canvasObj.freeDrawingBrush._points;
          if (pots.length > 20) {
            pots = pots.slice(-20);
          }
          var eraserPath = canvasObj.freeDrawingBrush.convertPointsToSVGPath(pots);
          var path = target.path;
          if (doPathsIntersect(eraserPath, path)) {
            // 移除文本元素
            emit('change', {
              optType: 'pencildel',
              drawId: target.drawId
            });
            canvasObj.remove(target);
          }
        }
      }
    };

    // 橡皮鼠标抬起
    var rubberMouseUp = function rubberMouseUp() {
      startRubber = false;
    };

    // 删除橡皮svg
    var removeRubberIcon = function removeRubberIcon() {
      canvasObj.getObjects().forEach(function (obj) {
        if (obj.elType === 'rubber') {
          canvasObj.remove(obj);
        }
      });
      rubberMouse = null;
      canvasObj.renderAll();
    };

    /************ 批注工具 ************/
    // 清空所有空批注点
    var clearNoteEmpty = function clearNoteEmpty() {
      canvasObj.getObjects().forEach(function (obj) {
        if (obj.elType === 'note-empty') {
          canvasObj.remove(obj);
        }
      });
    };
    // 添加批注时候鼠标按下
    var noteAddMouseDown = function noteAddMouseDown(e) {
      var target = e.target;
      var isEditNote = editing === 'note'; // 当前是否为编辑批注
      var addNote = /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
          var svg, imgObj;
          return _regenerator().w(function (_context5) {
            while (1) switch (_context5.n) {
              case 0:
                svg = require('@/assets/discuss/canvas-comment.png');
                _context5.n = 1;
                return getImgFabric(svg, {
                  elType: 'note-empty',
                  left: e.pointer.x,
                  top: e.pointer.y,
                  selectable: false,
                  // 不可选中
                  hasControls: false,
                  // 不可操控
                  hoverCursor: 'default' // 鼠标悬浮样式
                });
              case 1:
                imgObj = _context5.v;
                canvasObj.add(imgObj);
                noteX.value = e.pointer.x + 20;
                noteY.value = e.pointer.y - 20;
                noteSendShow.value = true;
                editing = 'note';
              case 2:
                return _context5.a(2);
            }
          }, _callee5);
        }));
        return function addNote() {
          return _ref6.apply(this, arguments);
        };
      }();
      if (isEditNote) {
        // 当前在编辑批注模式下，不添加元素，退出编辑模式
        editing = '';
        clearNoteEmpty();
        noteSendShow.value = false;
        return;
      }
      var isTextType = (target === null || target === void 0 ? void 0 : target.elType) === 'note'; // 当前点击元素是否为批注
      if (!target || target && !isTextType) {
        // 添加空批注点前，移除其他空批注点
        clearNoteEmpty();
        // 点击空白区域，或者点击元素不是批注，就添加元素
        addNote();
      }
    };

    // 获取最大批注序号
    var getAnSort = function getAnSort() {
      var _canvasObj$getObjects;
      var res = 0;
      var objs = (_canvasObj$getObjects = canvasObj.getObjects()) === null || _canvasObj$getObjects === void 0 ? void 0 : _canvasObj$getObjects.filter(function (e) {
        return e.elType === 'note';
      });
      if (objs.length) {
        objs.forEach(function (e) {
          var _e$_objects$;
          var sort = (_e$_objects$ = e._objects[1]) === null || _e$_objects$ === void 0 ? void 0 : _e$_objects$.text;
          if (res < Number(sort)) {
            res = Number(sort);
          }
        });
      }
      return res;
    };

    // 批注发送后，生成一个批注点
    var sendNote = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(noteId) {
        var sort, svg, imgObj, textObj, groupObj;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              noteSendShow.value = false;
              sort = (getAnSort() + 1).toString();
              svg = require('@/assets/discuss/canvas-comment-black.png');
              _context6.n = 1;
              return getImgFabric(svg);
            case 1:
              imgObj = _context6.v;
              textObj = new fabric.Text(sort, {
                top: -3,
                fontSize: 12,
                fill: '#fff',
                originX: 'center',
                originY: 'center'
              });
              groupObj = new fabric.Group([imgObj, textObj], {
                left: noteX.value - 20,
                top: noteY.value + 20,
                originX: 'center',
                originY: 'center',
                hoverCursor: 'pointer',
                hasControls: false,
                // 不显示控制的那9个按钮
                erasable: false,
                // 不可擦除
                selectable: false,
                // 不可选中
                elType: 'note',
                // 自定义属性：元素类型
                ownerId: userId,
                // 自定义属性：所属者id
                drawId: noteId // 图形唯一标识
              });
              canvasObj.add(groupObj);
              emit('change', {
                optType: 'markadd',
                drawId: noteId,
                drawContent: JSON.stringify(groupObj.toJSON())
              });
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }));
      return function sendNote(_x4) {
        return _ref7.apply(this, arguments);
      };
    }();

    // 删除批注列表后，批注点一同删除
    var delNoteDraw = function delNoteDraw(drawId) {
      emit('change', {
        optType: 'markdel',
        drawId: drawId
      });
      canvasObj.getObjects().forEach(function (obj) {
        if (obj.elType === 'note' && obj.drawId === drawId) {
          canvasObj.remove(obj);
        }
      });
    };

    // 画布工具改变
    var toolChange = function toolChange(info) {
      toolInfo = info;
      cancelTool();
      switch (info.tool) {
        case 'brush':
          brushTool();
          break;
        case 'rubber':
          rubberTool();
          break;
        case 'text':
          textTool();
          break;
        case 'note':
          noteTool();
          break;
        case 'clean':
          cleanTool();
          break;
        case 'save':
          saveTool();
          break;
      }
    };

    // 清空工具缓存
    var cancelTool = function cancelTool() {
      canvasObj.isDrawingMode = false;
      canvasObj.freeDrawingBrush = null;
      // 画笔相关清空
      canvasObj.off('object:added', brushObjectAdded);
      // 文本相关清空
      removeTextDeleteIcon();
      canvasObj.off('mouse:down', textMouseDown);
      // 橡皮相关清空
      startRubber = false;
      removeRubberIcon();
      canvasObj.off('mouse:down', rubberMouseDown);
      canvasObj.off('mouse:move', rubberMouseMove);
      canvasObj.off('mouse:up', rubberMouseUp);
      // 批注相关清空
      clearNoteEmpty();
      noteSendShow.value = false;
      noteX.value = 0;
      noteY.value = 0;
      canvasObj.off('mouse:down', noteAddMouseDown);
    };

    // 处理画笔工具
    var brushTool = function brushTool() {
      // 监听添加画笔
      canvasObj.on('object:added', brushObjectAdded);
      // 开启画布绘画模式
      canvasObj.isDrawingMode = true;
      canvasObj.freeDrawingBrush = new fabric.PencilBrush(canvasObj);
      canvasObj.freeDrawingBrush.width = toolInfo.thickness;
      canvasObj.freeDrawingBrush.color = toolInfo.color;
    };

    // 处理橡皮工具
    var rubberTool = function rubberTool() {
      var _toolInfo;
      // 开启橡皮绘画
      canvasObj.isDrawingMode = true;
      canvasObj.freeDrawingBrush = new fabric.EraserBrush(canvasObj);
      canvasObj.freeDrawingBrush.width = (_toolInfo = toolInfo) === null || _toolInfo === void 0 ? void 0 : _toolInfo.thickness;
      // 监听橡皮按下
      canvasObj.on('mouse:down', rubberMouseDown);
      // 监听橡皮移动
      canvasObj.on('mouse:move', rubberMouseMove);
      // 监听橡皮抬起
      canvasObj.on('mouse:up', rubberMouseUp);
    };

    // 处理文本工具
    var textTool = function textTool() {
      // 监听文本按下事件
      canvasObj.on('mouse:down', textMouseDown);
    };

    // 处理批注工具
    var noteTool = function noteTool() {
      // 监听批注按下事件
      canvasObj.on('mouse:down', noteAddMouseDown);
    };

    // 处理清除工具
    var cleanTool = function cleanTool() {
      var dialog = DialogPlugin({
        header: '提示',
        body: '是否清除该页面所有内容',
        theme: 'danger',
        cancelBtn: '取消',
        confirmBtn: {
          content: '确认',
          theme: 'danger'
        },
        onConfirm: function onConfirm() {
          canvasObj.clear();
          emit('change', {
            optType: 'clean'
          });
          dialog.destroy();
        }
      });
    };

    // 处理保存工具
    var saveTool = function saveTool() {
      if (savingPDF) {
        MessagePlugin.warning('正在保存为PDF，请稍后！');
        return;
      }
      savingPDF = true;
      try {
        canvasObj.loadFromJSON(canvasObj.toJSON(), function () {
          var img = canvasObj.toDataURL();
          var _canvasRef$value = canvasRef.value,
            width = _canvasRef$value.width,
            height = _canvasRef$value.height;
          var pdf = new jsPDF({
            orientation: 'landscape',
            unit: 'px',
            format: [width, height]
          });
          pdf.addImage(img, 'PNG', 0, 0, width, height);
          pdf.save('画布.pdf');
          MessagePlugin.success('保存成功！');
          savingPDF = false;
        });
      } catch (error) {
        MessagePlugin.error('保存失败！');
        savingPDF = false;
      }
    };

    // 抛出整个画布JSON
    var getCanvasJsonStr = function getCanvasJsonStr() {
      removeRubberIcon();
      removeTextDeleteIcon();
      var json = canvasObj.toJSON(['elType', 'ownerId', 'drawId', 'selectable', 'hoverCursor', 'hasControls']);
      return JSON.stringify(json);
    };

    // 画布添加元素
    var addElements = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(eles) {
        var i, e, drawJson, draw, _drawJson$objects$, svg, imgObj, textObj;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              i = 0;
            case 1:
              if (!(i < eles.length)) {
                _context7.n = 7;
                break;
              }
              e = eles[i];
              drawJson = JSON.parse(e.drawContent);
              draw = null;
              if (!(drawJson.type === 'path')) {
                _context7.n = 2;
                break;
              }
              draw = new fabric.Path(drawJson.path, {
                elType: 'brush',
                // 自定义属性：元素类型
                left: drawJson.left,
                // 路径左上角的X坐标
                top: drawJson.top,
                // 路径左上角的Y坐标
                fill: null,
                stroke: drawJson.stroke,
                // 描边颜色
                strokeWidth: drawJson.strokeWidth,
                // 描边宽度
                selectable: false,
                // 不可选中
                hoverCursor: 'default'
              });
              _context7.n = 5;
              break;
            case 2:
              if (!(drawJson.type === 'i-text')) {
                _context7.n = 3;
                break;
              }
              draw = new fabric.IText(drawJson.text, {
                elType: 'text',
                // 自定义属性：元素类型
                left: drawJson.left,
                // 路径左上角的X坐标
                top: drawJson.top,
                // 路径左上角的Y坐标
                fill: drawJson.fill,
                fontSize: drawJson.fontSize,
                hoverCursor: 'text',
                selectable: isHavePermission(e.ownerId)
              });
              _context7.n = 5;
              break;
            case 3:
              if (!(drawJson.type === 'group')) {
                _context7.n = 5;
                break;
              }
              svg = require('@/assets/discuss/canvas-comment-black.png');
              _context7.n = 4;
              return getImgFabric(svg);
            case 4:
              imgObj = _context7.v;
              textObj = new fabric.Text((_drawJson$objects$ = drawJson.objects[1]) === null || _drawJson$objects$ === void 0 ? void 0 : _drawJson$objects$.text, {
                top: -3,
                fontSize: 12,
                fill: '#fff',
                originX: 'center',
                originY: 'center'
              });
              draw = new fabric.Group([imgObj, textObj], {
                elType: 'note',
                // 自定义属性：元素类型
                left: drawJson.left,
                // 路径左上角的X坐标
                top: drawJson.top,
                // 路径左上角的Y坐标
                originX: 'center',
                originY: 'center',
                selectable: false,
                // 不可选中
                hoverCursor: 'pointer'
              });
            case 5:
              if (draw) {
                draw.set({
                  drawId: e.drawId,
                  ownerId: e.ownerId,
                  hasControls: false // 不显示控制的那9个按钮
                });
                canvasObj.add(draw);
              }
            case 6:
              i++;
              _context7.n = 1;
              break;
            case 7:
              return _context7.a(2);
          }
        }, _callee7);
      }));
      return function addElements(_x5) {
        return _ref8.apply(this, arguments);
      };
    }();
    __expose({
      cancelTool: cancelTool,
      toolChange: toolChange,
      getCanvasJsonStr: getCanvasJsonStr,
      addElements: addElements
    });

    /* 钩子 */
    onMounted(function () {
      initCanvas();
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "canvasBoxRef",
        ref: canvasBoxRef,
        class: "canvas-panel"
      }, [_createElementVNode("canvas", {
        ref_key: "canvasRef",
        ref: canvasRef
      }, null, 512), noteSendShow.value ? (_openBlock(), _createBlock(_unref(NoteSend), {
        key: 0,
        x: noteX.value,
        y: noteY.value,
        onSend: sendNote
      }, null, 8, ["x", "y"])) : _createCommentVNode("", true), noteListShow.value ? (_openBlock(), _createBlock(_unref(NoteList), {
        key: 1,
        x: noteX.value,
        y: noteY.value,
        pointId: noteInfo.value.id,
        ownerId: noteInfo.value.ownerId,
        onClose: _cache[0] || (_cache[0] = function ($event) {
          return noteListShow.value = false;
        }),
        onDelPoint: delNoteDraw
      }, null, 8, ["x", "y", "pointId", "ownerId"])) : _createCommentVNode("", true)], 512);
    };
  }
};